import StateView from "@components/StateView/StateView";
import WishlistModel from "@model/wishlist/wishlistModel";
import { makeAutoObservable, set } from "mobx";
import { WishlistService } from "../../../queries/wishlist/wishlist.service";

export default class wishlistController {
  list = [];
  item = {};
  curren_page = "";
  pageSize = "";
  total = "";
  wishlist = new WishlistModel();
  stateView = StateView.State.loading;
  loading = false;
  url = "";
  constructor() {
    makeAutoObservable(this);
  }

  getData = () => {
    this.stateView = StateView.State.loading;
    const res = WishlistService.list()
      .then((res) => {
        // this.stateView = StateView.State.content;
        const a = [];
        res.data.map((item, index) => {
          const temp = new WishlistModel();
          set(temp, item);
          a.push(temp);
        });
        this.list = a;
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  wishlistItems = (id) => {
    this.stateView = StateView.State.loading;
    const res = WishlistService.wishItem(id)
      .then((res) => {
        // this.stateView = StateView.State.content;
        this.list = res.offers;
        this.item = res.wishlist;
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  showSharedWish = (code) => {
    this.stateView = StateView.State.loading;
    const res = WishlistService.wishItemShared(code)
      .then((res) => {
        // this.stateView = StateView.State.content;
        this.list = res.offers;
        this.item = res.wishlist;
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  createShared = (id, callback) => {
    this.stateView = StateView.State.loading;
    const res = WishlistService.createShared(id)
      .then((res) => {
        // this.stateView = StateView.State.content;
        this.url = res.item.token;
        callback();
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  create = (data, callback) => {
    this.stateView = StateView.State.loading;
    const res = WishlistService.create(data)
      .then((res) => {
        callback(res.id);
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  deleteWishlist = (id, callback) => {
    this.stateView = StateView.State.loading;
    const res = WishlistService.deleteWishlist(id)
      .then((res) => {
        callback();
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  wishlistTitleUpdate = (id, title, callback) => {
    this.stateView = StateView.State.loading;
    const res = WishlistService.userWishlistUpdate(id, title)
      .then((res) => {
        callback();
      })
      .catch((e) => {
        console.log(e);
      });
  };
  selectWishlistitem = (id, uuid, offer, callback) => {
    this.stateView = StateView.State.loading;
    const res = WishlistService.setItemWishlist(id, uuid)
      .then((res) => {
        offer.wished = 1;
        this.stateView = StateView.State.content;
        callback();
        let indexx = this.list.findIndex((item) => item.code == uuid);
        this.list.splice(indexx, 1);
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
  removeWishlistitem = (id, offer) => {
    this.stateView = StateView.State.loading;
    const res = WishlistService.removeItemWishlist(id)
      .then((res) => {
        offer.wished = 0;
        let indexx = this.list.findIndex((item) => item.code == offer.uuid);
        this.list.splice(indexx, 1);
        this.stateView = StateView.State.content;
      })
      .catch((e) => {
        this.stateView = StateView.State.error;
      });
  };
}
